import _ from 'lodash';

export const isEmbedEnabled = ({ videoItem }) =>
  _.get(videoItem, 'embedOptions.enabled', false);
